<template>

    <div>中医健康体检活动</div>
</template>

<script>
export default {

}
</script>

	<div class="physical-form">
    <div class="physical-img">图片</div>
    <div class="physical-introduce">
      <div class="physical-title">
        <p>活动介绍</p>
        <div class="physical-content">
          <span>&nbsp; &nbsp; &nbsp;力菲健康管理通过权威、专业、准确的各项体检项目，极力打造中、高端健康人群“健康管理一站式服务”，做到：不仅仅是能让您获得健康身体，更能让您从此走进一种绿色的健康生活方式。</span>
          <br />
          <br />
          <span>活动开始时间：2019-08-04</span>
          <br />
          <span>活动结束时间：2019-09-12</span>
        </div>
      </div>
    </div>
    <!-- 表单 -->
    <div class="physical-sheet">
      <div class="stuff">
        <span>姓&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;名:</span>
        <input type="text" />
      </div>
      <div class="stuff">
        <span>性&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;别:</span>
        <input type="text" />
      </div>
      <div class="stuff">
        <span>联系电话:</span>
        <input type="text" />
      </div>
      <div class="stuff">
        <span>出生日期:</span>
        <input type="text" />
      </div>

      <div class="submit">
        <button>报名参加</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="less" scoped>
.physical-form {
  padding: 0 0.32rem;
  background-size: 100%;
  min-height: 100%;
  background-color: #7ee68c;
  padding-top: 0.36rem;
  box-sizing: border-box;
}
.physical-img {
  width: 100%;
  height: 3rem;
  background-color: rgb(255, 255, 255);
  border-radius: 0.2rem;
  margin-bottom: 0.32rem;
}
.physical-introduce {
  width: 100%;
  height: 4.2rem;
  background-color: rgb(255, 255, 255);
  border-radius: 0.2rem;
  margin-bottom: 0.32rem;
  .physical-title {
    width: 100%;
    height: 0.92rem;
    border-bottom: 0.01rem solid rgb(238, 238, 238);

    p {
      //   padding-top: 0.3rem;
      line-height: 0.92rem;
      padding-left: 0.19rem;
      font-size: 0.3rem;
      color: rgb(51, 51, 51);
    }
  }
}
.physical-content {
  span {
    padding-left: 0.19rem;
    font-size: 0.26rem;
    color: rgb(51, 51, 51);
  }
}
.physical-sheet {
  width: 100%;
  height: 5.92rem;
  background-color: rgb(255, 255, 255);
  border-radius: 0.2rem;
}

.physical-sheet {
  padding-top: 0.32rem;
  span {
    padding-left: 0.34rem;
    font-size: 0.3rem;
    color: rgb(51, 51, 51);
    padding-right: 0.24rem;
  }
  input {
    width: 4.8rem;
    height: 0.8rem;
    border-radius: 0.1rem;
    border: 0;
    background: #eeeeee;
    padding-left: 0.2rem;
    box-sizing: border-box;
    margin-bottom: 0.24rem;
  }
}
.submit {
  text-align: center;
  padding-top: 0.48rem;
}
.submit button {
  width: 4rem;
  height: 0.88rem;
  font-size: 0.3rem;
  color: rgb(255, 255, 255);
  border-radius: 0.2rem;
  background-size: 100%;
  border: 0;
  text-align: center;
  background-color: rgb(77, 205, 112);
}
</style>
